import React from "react";

const UserOffline: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6 pt-16 transition-colors">
            <div className="text-6xl mb-4">📡</div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                You're Offline
            </h1>
            <p className="text-gray-500 dark:text-gray-400 max-w-md">
                It looks like you've lost your internet connection. Please check your
                network and try again.
            </p>
        </div>
    );
};

export default UserOffline;
